const Loading = () => (
  <div className="loading" id="loader">
    <div className="spinner" />
  </div>
)
export default Loading
